module.exports = __webpack_public_path__ + "static/img/jigou-qinghai-top.a277eb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-qinghai-top.png
// module id = Et2o
// module chunks = 2